import { styled } from 'helpers'

export const Circle = styled('div')(({ color, size = 8 }) => ({
  backgroundColor: color,
  width: size,
  height: size,
  borderRadius: 2
}))
